import { createTheme, Theme } from '@mui/material/styles';
import { theme } from 'constants/styled-theme';

declare module '@mui/material/styles' {
  interface CustomTheme extends Theme {
    colors: {
      [key: string]: any;
    };
    icons: {
      [key: string]: any;
    };

    fonts: {
      [key: string]: any;
    };
  }
}
// allow configuration using `createTheme`
export interface ThemeOptions {
  colors: {
    [key: string]: any;
  };
  icons: {
    [key: string]: any;
  };

  fonts: {
    [key: string]: any;
  };
}

const customTheme = {
  ...theme,
  palette: {
    ...theme.colors,
    primary: {
      main: theme.colors.siteBlue,
      light: theme.colors.siteBlueLight,
      dark: theme.colors.hoverBorderSiteBlue,
      white: theme.colors.white
    }
  },
  // spacing: {
  //   mui: true
  // },
  typography: {
    fontSize: 14,
    fontFamily: theme.fonts.montserratMedium,
    fontMedium: theme.fonts.montserratRegular,
    fontBold: theme.fonts.montserratSemiBold,
    fontSemiBold: theme.fonts.montserratSemiBold,
    fontLight: theme.fonts.montserratLight,
    h1: { fontFamily: theme.fonts.montserratBold },
    h2: { fontFamily: theme.fonts.montserratMedium, fontSize: '2.1rem' },
    h3: { fontFamily: theme.fonts.montserratSemiBold },
    h4: { fontFamilly: theme.fonts.montserratSemiBold },
    h5: { fontFamily: theme.fonts.montserratSemiBold },
    h6: { fontFamily: theme.fonts.montserratSemiBold },
    subtitle1: { fontFamily: theme.fonts.montserratSemiBold, fontSize: '1.4rem' },
    subtitle2: { fontFamily: theme.fonts.montserratMedium, fontSize: '1.6rem' },
    body1: { fontFamily: theme.fonts.montserratRegular, fontSize: '1.4rem' },
    body2: { fontFamily: theme.fonts.montserratLight, fontSize: '1.2rem' },
    button: { fontFamily: theme.fonts.montserratSemiBold },
    caption: { fontFamily: theme.fonts.montserratRegular, fontSize: '0.8rem' },
    components: {
      MuiTypography: { root: { fontFamily: theme.fonts.montserratMedium, fontSize: '1.4rem' } }
    }
  }
};

export const muiTheme = createTheme(customTheme);
